import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 412,
	height: 141,
	viewBox: "0 0 412 141",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M44.0426 97.1746C43.8326 97.1846 43.6226 97.1346 43.4326 97.0047C42.9826 96.6947 42.8626 96.0845 43.1726 95.6345L48.9326 87.1946C49.1026 86.9446 49.3826 86.7845 49.6826 86.7645C49.9626 86.7345 50.2826 86.8646 50.4826 87.0846L54.2026 91.1746L60.8726 80.1345C61.0326 79.8745 61.2926 79.7046 61.5926 79.6646C61.8926 79.6346 62.1926 79.7346 62.4126 79.9446L66.4626 83.9746L75.0126 71.4346C75.3226 70.9846 75.9326 70.8646 76.3826 71.1746C76.8326 71.4846 76.9527 72.0946 76.6427 72.5446L67.4326 86.0646C67.2726 86.3046 67.0026 86.4646 66.7126 86.4946C66.4026 86.5346 66.1326 86.4146 65.9226 86.2146L61.9226 82.2346L55.2226 93.3346C55.0626 93.6046 54.7826 93.7746 54.4726 93.8046C54.1426 93.8446 53.8526 93.7146 53.6426 93.4846L49.8726 89.3446L44.8226 96.7547C44.6426 97.0147 44.3526 97.1646 44.0626 97.1846L44.0426 97.1746Z",
			fill: "#40C676"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 82.1012,
			y1: 31.4395,
			x2: 17.1012,
			y2: 46.4395,
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 60.8112,
			y2: -.45,
			transform: "matrix(0.707107 0.707107 0.707107 -0.707107 95 35.001)",
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.99999 56.001C13.4183 56.001 17 52.4193 17 48.001C17 43.5827 13.4183 40.001 8.99999 40.001C4.58171 40.001 1 43.5827 1 48.001C1 52.4193 4.58171 56.001 8.99999 56.001Z",
			stroke: "#DBDEE6",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M8.99999 51.001C10.6568 51.001 12 49.6578 12 48.001C12 46.3441 10.6568 45.001 8.99999 45.001C7.34313 45.001 6 46.3441 6 48.001C6 49.6578 7.34313 51.001 8.99999 51.001Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90 37.002C94.4183 37.002 98 33.4202 98 29.002C98 24.5837 94.4183 21.002 90 21.002C85.5817 21.002 82 24.5837 82 29.002C82 33.4202 85.5817 37.002 90 37.002Z",
			stroke: "#DBDEE6",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M90 32.002C91.6569 32.002 93 30.6588 93 29.002C93 27.3451 91.6569 26.002 90 26.002C88.3431 26.002 87 27.3451 87 29.002C87 30.6588 88.3431 32.002 90 32.002Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 74.3229,
			y2: -.45,
			transform: "matrix(-0.920735 -0.390189 -0.390189 0.920735 284.432 129.002)",
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 55.4437,
			y2: -.45,
			transform: "matrix(0.991998 0.126254 0.126254 -0.991998 340 63.002)",
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 64.0078,
			y2: -.45,
			transform: "matrix(0.484316 -0.874893 -0.874893 -0.484316 297 126.002)",
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 55.002C336.418 55.002 340 58.5837 340 63.0019C340 67.4202 336.418 71.002 332 71.002C327.582 71.002 324 67.4202 324 63.0019C324 58.5837 327.582 55.002 332 55.002Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 60.002C333.657 60.002 335 61.3451 335 63.002C335 64.6588 333.657 66.002 332 66.002C330.343 66.002 329 64.6588 329 63.002C329 61.3451 330.343 60.002 332 60.002Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 63.002C407.418 63.002 411 66.5837 411 71.002C411 75.4202 407.418 79.002 403 79.002C398.582 79.002 395 75.4202 395 71.002C395 66.5837 398.582 63.002 403 63.002Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 68.002C404.657 68.002 406 69.3451 406 71.002C406 72.6588 404.657 74.002 403 74.002C401.343 74.002 400 72.6588 400 71.002C400 69.3451 401.343 68.002 403 68.002Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M292 124.002C296.418 124.002 300 127.584 300 132.002C300 136.42 296.418 140.002 292 140.002C287.582 140.002 284 136.42 284 132.002C284 127.584 287.582 124.002 292 124.002Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M292 129.002C293.657 129.002 295 130.345 295 132.002C295 133.659 293.657 135.002 292 135.002C290.343 135.002 289 133.659 289 132.002C289 130.345 290.343 129.002 292 129.002Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M39.2999 18.6519C39.2999 20.6719 37.6699 22.3019 35.6499 22.3019C33.6299 22.3019 32 20.6719 32 18.6519C32 16.6319 33.6299 15.002 35.6499 15.002C37.6699 15.002 39.2999 16.6319 39.2999 18.6519Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M351.3 100.652C351.3 102.672 349.67 104.302 347.65 104.302C345.63 104.302 344 102.672 344 100.652C344 98.6319 345.63 97.002 347.65 97.002C349.67 97.002 351.3 98.6319 351.3 100.652Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 121,
			width: 170,
			height: 112,
			rx: 8,
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 125,
			y: 4,
			width: 162,
			height: 93,
			rx: 4,
			fill: "#E9EBF0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M209.15 104.2C209.15 105.971 207.715 107.4 205.95 107.4C204.184 107.4 202.75 105.965 202.75 104.2C202.75 102.435 204.184 101 205.95 101C207.715 101 209.15 102.435 209.15 104.2Z",
			stroke: "white",
			strokeWidth: .9,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M172.881 133C172.881 129.465 175.746 126.6 179.281 126.6H230.481C234.015 126.6 236.881 129.465 236.881 133H172.881Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 187.816,
			y: 111.667,
			width: 34.1333,
			height: 14.9333,
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M208.083 118.067C203.389 115.08 192.616 114.333 187.816 114.333V111.667H221.949V126.6H219.816C217.86 125 212.776 121.053 208.083 118.067Z",
			fill: "#002347"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M129 97.002C126.791 97.002 125 95.2111 125 93.002L125 8.00195C125 5.79282 126.791 4.00195 129 4.00195L146 4.00195L146 97.002L129 97.002Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 134.95,
			y1: 24.452,
			x2: 129.45,
			y2: 24.452,
			stroke: "#D9DEEB",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 139.22,
			y1: 29.452,
			x2: 129.453,
			y2: 29.452,
			stroke: "#006ADC",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 134.95,
			y1: 34.452,
			x2: 129.45,
			y2: 34.452,
			stroke: "#D9DEEB",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 139.22,
			y1: 39.452,
			x2: 129.453,
			y2: 39.452,
			stroke: "#D9DEEB",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 134.95,
			y1: 44.452,
			x2: 129.45,
			y2: 44.452,
			stroke: "#D9DEEB",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 139.22,
			y1: 49.452,
			x2: 129.453,
			y2: 49.452,
			stroke: "#D9DEEB",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M260.546 12.6314C260.546 13.8657 259.548 14.8634 258.314 14.8634C257.08 14.8634 256.082 13.8657 256.082 12.6314C256.082 11.397 257.08 10.3994 258.314 10.3994C259.548 10.3994 260.546 11.397 260.546 12.6314Z",
			fill: "#3085E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M269.771 12.6314C269.771 13.8657 268.773 14.8634 267.539 14.8634C266.305 14.8634 265.307 13.8657 265.307 12.6314C265.307 11.397 266.305 10.3994 267.539 10.3994C268.773 10.3994 269.771 11.397 269.771 12.6314Z",
			fill: "#3085E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M279.586 12.6314C279.586 13.8657 278.588 14.8634 277.354 14.8634C276.119 14.8634 275.122 13.8657 275.122 12.6314C275.122 11.397 276.119 10.3994 277.354 10.3994C278.588 10.3994 279.586 11.397 279.586 12.6314Z",
			fill: "#3085E1"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 158,
			y: 29.002,
			width: 12,
			height: 12,
			rx: 3,
			fill: "#3085E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M167.5 32.002H166.245L166.169 32.0028C165.937 31.9986 165.853 32.0883 165.784 32.1989L164.798 33.7148L163.853 32.2294L163.822 32.1807C163.822 32.1807 163.796 32.1372 163.751 32.1356H163.75C163.705 32.1372 163.679 32.1807 163.679 32.1807L163.648 32.2294L162.735 33.7148L161.717 32.1989C161.647 32.0883 161.563 31.9986 161.332 32.0028L161.256 32.002H160L160.001 33.2397H160.74C160.896 33.2382 160.968 33.2458 161.075 33.3788L161.119 33.4461L162.613 35.8699C162.613 35.8699 162.662 35.9482 162.744 35.9486C162.833 35.9489 162.882 35.8697 162.882 35.8697L163.752 34.5173H163.752L164.657 35.8679C164.657 35.8679 164.708 35.948 164.784 35.95C164.867 35.9521 164.912 35.8697 164.912 35.8697L166.383 33.4461L166.427 33.3788C166.504 33.2548 166.6 33.2418 166.755 33.2433L167.495 33.2428L167.5 32.002Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M165.609 35.4427L164.805 36.7662L163.768 35.2069L162.97 36.4513L164.654 39.188C164.713 39.2636 164.759 39.2795 164.782 39.2803C164.833 39.2826 164.863 39.2544 164.917 39.1586L166.237 36.6597C166.354 36.4427 166.551 36.4455 166.551 36.4455H167.503L167.502 35.2093H166.015C165.744 35.2093 165.609 35.4427 165.609 35.4427Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 228.55,
			y1: 33.452,
			x2: 174.45,
			y2: 33.452,
			stroke: "#3085E1",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 264.55,
			y1: 36.452,
			x2: 174.45,
			y2: 36.452,
			stroke: "#3085E1",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 158.45,
			y: 47.452,
			width: 11.1,
			height: 11.1,
			rx: 2.55,
			stroke: "white",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 228.55,
			y1: 51.452,
			x2: 174.45,
			y2: 51.452,
			stroke: "white",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 264.55,
			y1: 54.452,
			x2: 174.45,
			y2: 54.452,
			stroke: "white",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 158.45,
			y: 65.452,
			width: 11.1,
			height: 11.1,
			rx: 2.55,
			stroke: "white",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 228.55,
			y1: 69.452,
			x2: 174.45,
			y2: 69.452,
			stroke: "white",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 264.55,
			y1: 72.452,
			x2: 174.45,
			y2: 72.452,
			stroke: "white",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.78 96.734C115.781 107.934 119.734 117.148 134.321 117.213",
			stroke: "#002E5F",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 129,
			y: 11.002,
			width: 11,
			height: 4,
			rx: 2,
			fill: "#D9DEEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M347.043 21.012C346.833 21.002 346.623 21.0519 346.433 21.1819C345.983 21.4919 345.863 22.102 346.173 22.552L351.933 30.9919C352.103 31.2419 352.383 31.402 352.683 31.422C352.963 31.452 353.283 31.3219 353.483 31.1019L357.203 27.012L363.873 38.052C364.033 38.312 364.293 38.482 364.593 38.522C364.893 38.552 365.193 38.452 365.413 38.242L369.463 34.2119L370.5 33.1846C370.628 32.9263 370.593 32.362 370.433 32.122C370.273 31.882 370.003 31.7219 369.713 31.6919C369.403 31.6519 369.133 31.7719 368.923 31.9719L364.923 35.9519L358.223 24.8519C358.063 24.5819 357.783 24.412 357.473 24.382C357.143 24.342 356.853 24.4719 356.643 24.7019L352.873 28.8419L347.823 21.4319C347.643 21.1719 347.353 21.022 347.063 21.002L347.043 21.012Z",
			fill: "#40C676"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 248,
			y: 57.3193,
			width: 52,
			height: 32,
			rx: 4,
			transform: "rotate(-12.5724 248 57.3193)",
			fill: "#3085E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M254.945 60.8934L276.031 72.7823C277.368 73.5361 279.059 73.1591 279.949 71.9086L293.985 52.1865",
			stroke: "#7DB2EB",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 259.865,
			y1: 82.7118,
			x2: 269.615,
			y2: 69.8628,
			stroke: "#7DB2EB",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 285.289,
			y1: 65.3966,
			x2: 298.903,
			y2: 74.0458,
			stroke: "#7DB2EB",
			strokeWidth: .9,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgEmail);
export default ForwardRef;
